import InvitationApi from '@/api/invitation'
import accountApi from '@/api/account'

const actions = {
  createInvitationsAction: async ({ rootGetters }, payload) => {
    const extraParams = {}
    if (rootGetters['multipleSessions/canLimitInviteSent']) {
      extraParams.limitedAddInvitations = true
    }
    extraParams.v = 2
    if (rootGetters['featureToggles/canReplyToSender']) {
      extraParams.enableSenderReplyTo = true
    }
    return InvitationApi.createInvitations(payload, extraParams)
  },

  createAccountAction: async (_, payload) => {
    const extraParams = { v: 2 }
    return accountApi.createAccount(payload, extraParams)
  },
}

export default actions
